<template>
  <div class="section">
    <!-- Header -->
    <section class="hero hero-attached">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Anexos
          </h1>
          <h2 class="subtitle is-size-6">
            {{ dataFiles.items.length }} archivos
          </h2>
        </div>
      </div>
    </section>
    <!-- Content -->
    <section class="grey-lightm box">
      <div style="margin-bottom: 10px;">
        <span>Archivos</span>
      </div>
      <!-- Files -->
      <div class="colFlex">
        <!-- Upload img only xlsx, docx y pdf -->
        <div
          v-if="
            tokenUser &&
              !tokenUser['admin'] &&
              dataFiles.items.length < 1 &&
              !loading
          "
          class="content-file is-justify-center"
        >
          <div class="file-label">
            <img
              src="@/assets/icons/find-folder.png"
              width="95"
              height="95"
              alt="www.icons8.com"
            />
          </div>
          <span class="is-size-7 name-file">No hay archivos</span>
        </div>
        <div
          v-if="tokenUser && tokenUser['admin']"
          class="content-file is-justify-center"
        >
          <div class="file-label">
            <img
              src="@/assets/icons/add-file.png"
              width="95"
              height="95"
              alt="www.icons8.com"
            />
            <input
              v-on:change="onFileChange"
              ref="inputFileFrs"
              type="file"
              class="file-input"
              name="file"
              id="file"
              :accept="inputAccept"
              style="cursor: pointer;"
            />
          </div>
          <span class="is-size-7 name-file">Subir archivo</span>
        </div>
        <div v-if="loading" class="content-file is-justify-center">
          <div class="file-label">
            Cargando...
            <progress
              style="margin-left: 10px; margin-right: 10px"
              class="progress is-small is-grey-dark"
              max="100"
              >15%</progress
            >
          </div>
        </div>
        <card-file-upload
          v-for="(v, k) in dataFiles.items"
          :key="k"
          :file="v"
          :createLogAttached="createLogAttached"
          @getFiles="getFiles"
        ></card-file-upload>
      </div>
    </section>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import cardFileUpload from "./components/cardFileUpload.vue";

export default {
  data() {
    return {
      loading: false,
      dataFiles: {
        items: [],
      },
      filesAccept: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "application/pdf,application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
      ],
      inputAccept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.ms-excel, application/pdf,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf",
    };
  },
  props: {
    process: Object,
    tokenUser: Object,
  },
  beforeMount() {
    if (this.process._id) {
      this.process.id = this.process._id;
    }
    this.getFiles();
  },
  methods: {
    getFiles: function() {
      this.loading = true;
      const files = this.$fire.getAttached(this.process.id);
      files
        .then((result) => {
          this.dataFiles = result;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("notify", {
            message: "Error al obtener los datos",
            type: "is-danger",
            duration: 4000,
            position: "top-center",
          });
          this.loading = false;
        });
    },
    onFileChange(e) {
      const files = e.target.files;
      if (!files.length) return;

      const file = files[0];

      if (!this.filesAccept.includes(file.type)) return this.errorFile();

      const upload = this.$fire.saveAttached(file, this.process.id);
      this.$swal({
        icon: "info",
        html: "Subiendo archivo...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
        timer: 5000,
      });
      upload
        .then(async (data) => {
          const { metadata } = data;

          if (metadata) {
            await this.createLogAttached(metadata, "create");
          }
          this.getFiles();
          await this.$swal({
            text: "Archivo cargado correctamente.",
            icon: "success",
            showConfirmButton: false,
            timer: 1700,
          });
          this.$swal.close();
          this.deleteFile();
        })
        .catch((error) => {
          this.$swal.close();
          this.$swal({
            text: "Error al cargar el archivo.",
            icon: "error",
            showConfirmButton: false,
            timer: 1700,
          });
          console.log(error);
        });
    },
    async createLogAttached(metadata, action) {
      if (!metadata) return;

      // Tamaño del archivo en bytes
      const sizeBytes = metadata.size;
      // Convertir el tamaño del archivo a megabytes
      const sizeMB = sizeBytes / 1048576;
      // Sacar el nombre orginal
      let name = "";
      metadata.name.split("-").map((e, k) => {
        if (k > 0) {
          name += " " + e;
        }
      });
      const log = {
        action,
        collection_name: "ClimaAnexos",
        document_id: this.process.id,
        before: {
          name,
          size: sizeMB,
          ex: metadata.name.split(".").pop(),
          process: this.process.id,
          idName: metadata.name,
          create: metadata.timeCreated,
        },
        timestamp: new Date(),
      };
      await apiServices.post("/logs/create", log);
    },
    // Helpers
    deleteFile() {
      this.$refs.inputFileFrs = null;
    },
    errorFile() {
      this.$store.dispatch("notify", {
        message: `El archivo no es un Excel, Word o PDF`,
        type: "is-danger",
      });
      this.deleteFile();
    },
  },
  watch: {},
  components: {
    cardFileUpload,
  },
};
</script>
<style lang="scss">
.grey-lightm {
  background: #f1f1f1 !important;
}
.content-file {
  width: 160px !important;
  height: 160px !important;
  background: white !important;
  border-radius: 6px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  color: #4a4a4a;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0.5rem 1rem 0.5rem; // top - right - bottom - left
  text-align: center;
}
.header-file {
  display: flex;
  justify-items: start;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.header-file .icon-options {
  background-color: #f1f1f1;
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
}
.colFlex {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 12px;
}
.color-dark {
  color: #510087;
}
.file-label {
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: relative;
  height: 100%;
  width: 100%;
  align-content: center;
  flex-wrap: wrap;
  cursor: default;
}
.name-file {
  width: 100%;
  text-overflow: ellipsis !important;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: inline-block;
  text-transform: initial;
}

.hero-attached .hero-body {
  padding: 1rem 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/attached/uploadFilesBoard.vue